import { Checkbox } from "@mui/material"
import { ComponentProps, Dispatch, SetStateAction } from "react"
import styles from './CheckInput.module.scss'

export interface CheckInputProps extends ComponentProps<"input"> {
  checked: boolean
  setValue?: (val: boolean) => void | Dispatch<SetStateAction<boolean>>
}
const CheckInput = (props: CheckInputProps) => {
  const {checked, setValue} = props

  return (
    <Checkbox className={styles.checkbox} checked={checked} onChange={e => {setValue?.(e.target.checked)}}/>
  )
}

export default CheckInput